// import axios from "axios";
// import Image from "../ui/Image";

// import React from "react";
// import { Link } from "react-router-dom";
// import { useQuery } from "@tanstack/react-query";
// import { useTranslation } from "react-i18next";
// import { useLanguage } from "../../store/language-context";
// import Breadcrumb from "../Pages/Breadcrumb";

// const AllBlog = () => {
//   const { URL } = useLanguage();
//   const { t } = useTranslation();
//   const { data: blogs = [], isLoading, error, refetch } = useQuery({
//     queryKey: ['blogs', URL],
//     queryFn: async () => {
//       const response = await axios.get(`${URL}/blogs?per_page=400`);
//       if (response.data.status === 200) {
//         return response?.data?.data?.data;
//       } else {
//         throw new Error(t('custom.err'));
//       }
//     },
//     retry: 1,
//     refetchOnWindowFocus: false,
//     staleTime: 1000 * 60 * 60 * 6, // 6HR
//     gcTime: 1000 * 60 * 60 * 6,
//   });

//   return (
//     <main>
//       <Breadcrumb pages={[t("routes.all-blogs")]} />

//       <section className="container ">
//         {/* Check Loading or Error States */}
//         {isLoading ? (
//           <div className="grid grid-cols-3 gap-6">
//             {[...Array(6)].map((_, i) => (
//               <div key={i} className="relative flex justify-center flex-col">
//                 <div className="l-load w-96 h-60 rounded-md max-lg:w-full"></div>
//                 <div className="absolute z-20 bottom-3 flex flex-col items-center w-full px-2 space-y-1">
//                   <div className="l-load-dt w-3/4 h-5 rounded"></div>
//                   <div className="l-load-dt w-40 h-8 rounded-md"></div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : error ? (
//           <div className="text-center py-8">
//             <p className="text-red-500">{t('custom.err')}</p>
//             <button
//               className="mt-2 bg-secondary-tw text-white px-4 py-2 rounded-md"
//               onClick={() => refetch && refetch()}
//             >
//               {t('custom.try-again')}
//             </button>
//           </div>
//         ) : blogs.length === 0 ? (
//           <p className="text-center py-8">{t('custom.no-data')}</p>
//         ) : (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {blogs.map((item) => (
//               <div key={item?.id} className="bg-[#E6E6E6] shadow-md rounded-lg overflow-hidden border p-4">
//                 <div className="relative h-64 w-full">
//                   <Image
//                     src={item?.image || "/default-image.jpg"}
//                     alt={item?.title}
//                     className="object-cover w-full h-full mb-2"
//                     style={{ borderRadius: '16px', border: '2px solid #D4AD89' }}
//                   />
//                 </div>
//                 <div className="p-1">
//                   <h3 className="text-lg font-semibold text-[#5b2e47] mb-2 text-end mt-2">
//                     {item?.title}
//                   </h3>
//                   <Link to={`/blogs/${item?.id}`} className="text-sm text-[#b18c5e] flex items-center justify-end gap-1">
//                    {t('moreDetails')}  ← 
//                   </Link>
                  
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </section>
//     </main>
//   );
// };

// export default AllBlog;
import axios from "axios";
import Image from "../ui/Image";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../store/language-context";
import Breadcrumb from "../Pages/Breadcrumb";

const AllBlog = () => {
  const { URL } = useLanguage();
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const { data: blogs = [], isLoading, error, refetch } = useQuery({
    queryKey: ['blogs', URL, currentPage],
    queryFn: async () => {
      const response = await axios.get(`${URL}/blogs?per_page=12&page=${currentPage}`);
      if (response.data.status === 200) {
        setTotalPages(response.data.data.meta.last_page); // Set total pages from API response
        return response.data.data.data;
      } else {
        throw new Error(t('custom.err'));
      }
    },
    retry: 1,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 6, // 6HR
    gcTime: 1000 * 60 * 60 * 6,
  });

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <main>
      <Breadcrumb pages={[t("routes.all-blogs")]} />

      <section className="container ">
        {/* Check Loading or Error States */}
        {isLoading ? (
          <div className="grid grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="relative flex justify-center flex-col">
                <div className="l-load w-96 h-60 rounded-md max-lg:w-full"></div>
                <div className="absolute z-20 bottom-3 flex flex-col items-center w-full px-2 space-y-1">
                  <div className="l-load-dt w-3/4 h-5 rounded"></div>
                  <div className="l-load-dt w-40 h-8 rounded-md"></div>
                </div>
              </div>
            ))}
          </div>
        ) : error ? (
          <div className="text-center py-8">
            <p className="text-red-500">{t('custom.err')}</p>
            <button
              className="mt-2 bg-secondary-tw text-white px-4 py-2 rounded-md"
              onClick={() => refetch && refetch()}
            >
              {t('custom.try-again')}
            </button>
          </div>
        ) : blogs.length === 0 ? (
          <p className="text-center py-8">{t('custom.no-data')}</p>
        ) : (
          <div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {blogs.map((item) => (
                <div key={item?.id} className="bg-[#E6E6E6] shadow-md rounded-lg overflow-hidden border p-4"
                style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                  <div className="relative h-54 w-full">
                    <Image
                      src={item?.image || "/default-image.jpg"}
                      alt={item?.title}
                      className="object-cover w-full h-full mb-2"
                      style={{ borderRadius: '16px', border: '2px solid #D4AD89' }}
                    />
                  </div>
                  <div className="p-1" style={{minHeight: '120px',display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                    <h3 className=" fs-5 font-smibold text-[#5b2e47] mb-2 text-end mt-2">
                      {item?.title}
                    </h3>
                    <Link to={`/blogs/${item?.id}`} className="text-sm text-[#b18c5e] flex items-center justify-end gap-1">
                      {t('moreDetails')} ←
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="flex justify-center mt-6 pagination flex-wrap">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`px-3 py-1 border rounded text-sm flex items-center justify-center ${currentPage === 1 ? 'opacity-50 cursor-not-allowed bg-[#e5e7eb]' : 'hover:bg-gray-200 bg-white text-gray-700'} m-1`}
                >
                    →
               
                </button>

                {[...Array(totalPages).keys()].map((num) => {
                  const page = num + 1;
                  const isActive = page === currentPage;
                  return (
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      className={`px-3 py-1 border rounded text-sm m-1 ${isActive ? 'bg-[#6a2f38] text-white' : 'bg-white text-gray-700 hover:bg-gray-200'}`}
                    >
                      {page}
                    </button>
                  );
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className={`px-3 py-1 border rounded text-sm flex items-center justify-center ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed bg-[#e5e7eb]' : 'hover:bg-gray-200 bg-white text-gray-700'} m-1`}
                >
                      ← 
                </button>
              </div>
            )}
          </div>
        )}
      </section>
    </main>
  );
};

export default AllBlog;
